import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import familyImg from "@/assets/family-new-1.jpeg";
import tripleImg from "@/assets/triple-room-preview.jpeg";
import economyImg from "@/assets/economy-room-1.jpeg";
import room4 from "@/assets/room-4.png";
import suiteLiving from "@/assets/suite-living.jpg";
import { useLanguage } from "@/i18n/LanguageContext";
import { useCmsContent } from "@/hooks/useCmsContent";
import { useRoomContent } from "@/hooks/useRoomContent";

const HomeRooms = () => {
  const { t } = useLanguage();
  const { get } = useCmsContent();
  const { getRoom } = useRoomContent();

  const roomDefs = [
    { type: "double", fallback: t.homeRooms.doubleRoom, image: room4, link: "/rooms/double" },
    { type: "twin", fallback: t.homeRooms.twinRoom, image: economyImg, link: "/rooms/twin" },
    { type: "triple", fallback: t.homeRooms.tripleRoom, image: tripleImg, link: "/rooms/triple" },
    { type: "family", fallback: t.homeRooms.familyRoom, image: familyImg, link: "/rooms/family" },
    { type: "suite", fallback: t.homeRooms.suite, image: suiteLiving, link: "/rooms/suite" },
  ];

  const rooms = roomDefs.map((r) => ({
    name: getRoom(r.type)?.title || r.fallback,
    image: r.image,
    link: r.link,
  }));

  return (
    <section className="hotel-section bg-background">
      <div className="hotel-container">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12">
          <h2 className="hotel-heading text-foreground mb-4">{get("rooms_title") || t.homeRooms.heading}</h2>
          <p className="hotel-caption text-accent">{get("rooms_subtitle") || t.homeRooms.caption}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {rooms.map((room) => (
            <Link
              key={room.name}
              to={room.link}
              className="group flex flex-col overflow-hidden shadow-soft hover:shadow-elevated transition-all duration-500"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={room.image}
                  alt={room.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="bg-primary px-4 py-3 md:px-5 md:py-4 flex-1 flex flex-col justify-center">
                <h3 className="font-display text-sm md:text-lg font-semibold text-primary-foreground uppercase tracking-wide leading-tight">
                  {room.name}
                </h3>
                <span className="inline-flex items-center gap-1.5 font-body text-[10px] md:text-xs text-accent uppercase tracking-[0.15em] font-medium mt-1 group-hover:gap-2.5 transition-all duration-300">
                  {t.homeRooms.moreDetails}
                  <ArrowRight className="w-3 h-3 md:w-3.5 md:h-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeRooms;
